'use strict';
module.exports = require( './lib/u2f-api' );


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/u2f-api/index.js
 ** module id = 958
 ** module chunks = 1
 **/